/**
 * Lightweight, always-on console tracer for the demote -> visitor flow.
 *
 * These intentionally use `logger.*` (not meet-hour-logger) so they show up regardless of the
 * configured `defaultLogLevel` (which normally suppresses `log`/`info`/`debug` in production).
 *
 * To follow the flow in the browser, open DevTools console and filter by: VISITOR
 *
 * Remove (or gate behind a flag) once the visitor flow is stable.
 */
const BADGE = 'color:#fff;background:#7c4dff;padding:1px 5px;border-radius:3px;font-weight:bold';
/**
 * Logs a step in the visitor flow.
 *
 * @param {string} step - Short label of the current step.
 * @param {...any} args - Extra values to log.
 * @returns {void}
 */
export function vlog(step, ...args) {
    const MHlogger = console;
    MHlogger === null || MHlogger === void 0 ? void 0 : MHlogger.log(`%c[VISITOR]%c ${step}`, BADGE, 'color:#7c4dff', ...args);
}
/**
 * Logs a failure in the visitor flow (so silently-swallowed promise rejections become visible).
 *
 * @param {string} step - Short label of the step that failed.
 * @param {...any} args - The error and/or extra context.
 * @returns {void}
 */
export function verr(step, ...args) {
    const MHlogger = console;
    MHlogger === null || MHlogger === void 0 ? void 0 : MHlogger.error(`%c[VISITOR]%c ${step}`, BADGE, 'color:#c00;font-weight:bold', ...args);
}
